import { render, staticRenderFns } from "./targetCustomerMatching.vue?vue&type=template&id=4aca0a04&scoped=true"
import script from "./targetCustomerMatching.vue?vue&type=script&lang=js"
export * from "./targetCustomerMatching.vue?vue&type=script&lang=js"
import style0 from "./targetCustomerMatching.vue?vue&type=style&index=0&id=4aca0a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca0a04",
  null
  
)

export default component.exports